import { createBrowserRouter } from 'react-router-dom';
import App from './App';
import ConfigPage from './pages/ConfigPage/ConfigPage';
import LoginPage from './pages/LoginPage/LoginPage';
import PrivateRoute from "./components/PrivateRoute";
import FlowChart from "./pages/FlowChart/FlowChart";
import FlowChartHome from "./pages/FlowChart/FlowChartHome";
import FlowChartEdit from "./pages/FlowChart/FlowChartEdit";
import Dashboard from "./pages/Dashboard/Dashboard";
import SettingsPage from "./pages/SettingsPage/SettingsPage";
import CampaignsPage from "./pages/CampaignsPage/CampaignsPage";
import ContactsPage from "./pages/ContactsPage/ContactsPage";
import JoinWaitlist from "./pages/JoinWaitlist/JoinWaitlist";
import PrivacyPolicy from "./pages/HomePage/PrivacyPolicy";
import TermsNConditions from "./pages/HomePage/TermsNConditions";
import Security from "./pages/HomePage/Security";
import Compliance from "./pages/HomePage/Compliance";
import CrisisManagement from "./pages/HomePage/CrisisManagement";
import SitePage from "./pages/SecondaryPages/SitePage";
import CookiePolicy from "./pages/HomePage/CookiePolicy";
import HomePage from "./pages/HomePage/HomePage";
import EditBlog from "./pages/HomePage/EditBlog";
import Blogs from "./pages/HomePage/Blogs";
import ViewBlog from "./pages/HomePage/ViewBlog";

const routes = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      {
        path: "/",
        element: <HomePage />,
      },
      {
        path: "/joinwaitlist",
        element: <JoinWaitlist />,
      },

      {
        path: "/login",
        element: <LoginPage />,
      },
      {
        path: "/termsnconditions",
        element: <TermsNConditions />,
      },
      {
        path: "/privacypolicy",
        element: <PrivacyPolicy />,
      },
      {
        path: "/cookiepolicy",
        element: <CookiePolicy />,
      },
      {
        path: "/security",
        element: <Security />,
      },
      {
        path: "/compliance",
        element: <Compliance />,
      },
      {
        path: "/crisis_management",
        element: <CrisisManagement />,
      },
      {
        path: "/industries/:page_id",
        element: <SitePage />,
      },
      {
        path: "/use_case/:page_id",
        element: <SitePage />,
      },
      {
        path: "/blogs",
        children: [
          { path: "", element: <Blogs /> },
          {
            path: "blog/:blog_id",
            element: <ViewBlog />,
          },
          {
            path: "edit_blog/:blog_id",
            element: <EditBlog />,
          },
        ],
      },
    ],
  },
  {
    path: "dashboard",
    element: <PrivateRoute component={Dashboard} />,
    children: [
      {
        path: "flowchart",
        element: <PrivateRoute component={FlowChartHome} />,
      },
      {
        path: "flowchart/:id",
        element: <PrivateRoute component={FlowChart} />,
      },
      {
        path: "flowchart/edit/:id",
        element: <PrivateRoute component={FlowChartEdit} />,
      },
      {
        path: "configure",
        element: <PrivateRoute component={ConfigPage} />,
      },
      {
        path: "contacts",
        element: <PrivateRoute component={ContactsPage} />,
      },
      {
        path: "campaigns",
        element: <PrivateRoute component={CampaignsPage} />,
      },
      {
        path: "settings",
        element: <PrivateRoute component={SettingsPage} />,
      },
    ],
  },
]);

export default routes